export default "__VITE_ASSET__a3b7844c__"